// extracted by mini-css-extract-plugin
export default {"community":"RnDCommunity_community__aqRQy","community-text":"RnDCommunity_community-text__HhiPB","community-image":"RnDCommunity_community-image__vGypV"};